/**
 * Class representing a table used in DocumentContainer
 */
class Table {
  /**
   * @param {string} id
   * @param {Table} config
   * @param {Array} data
   * @param {Object} type
   * @param {string} [title]
   * @param {String} multiRowPath
   */
  constructor(id, config, data, type, title, multiRowPath, useLegacyFormatting) {
    this.id = id
    this.config = config
    this.data = data
    this.type = type
    this.title = title
    this.multiRowPath = multiRowPath
    this.useLegacyFormatting = useLegacyFormatting
  }

  /**
   * checks if the table has rows at all
   *
   * @returns {boolean}
   */
  hasRows() {
    return this.data.length > 0
  }

}

export {Table}



// WEBPACK FOOTER //
// ./src/model/table/Table.js